import '~/js/sections/weddings/includes/scroll-below';
// create new array for countries and appending a new object that represents default value

const countries = [
  {
    name: 'Select a Country',
    id: '',
    regionCode: '',
    code: ''
  },
  ...window.beaches_app.page.countries
];

// create new array for states and appending a new object that represents default value
const states = [
  ...window.beaches_app.page.states
];

import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';

ReactDOM.render(
  <CustomDatePicker
    name="arrivalDate"
    inputClassName="checkin-date-input"
    isRequired
    allowPast
    displayPlaceHolder
    displayStringDate={false}
  />,
  document.getElementById('arrival-date-picker-validate'),
);

ReactDOM.render(
  <CustomDatePicker
    name="departureDate"
    inputClassName="checkin-date-input"
    isRequired
    allowPast
    displayPlaceHolder
    displayStringDate={false}
  />,
  document.getElementById('departure-date-picker-validate'),
);

ReactDOM.render(
  <CountryStateSelector
    countries={ countries }
    states={ states }
    countryName="country"
    stateName="state"
    stateLabelWrapper="xs-12 lg-5"
    stateInputWrapper="xs-12 lg-7"
    countryLabelWrapper="xs-12 lg-5"
    countryInputWrapper="xs-12 lg-7"
  />,
  document.getElementById('country-state-selector')
);

ReactDOM.render(
  <CustomRecaptcha
    wrapperClassName="xs-12 lg-12"
  />,
  document.getElementById('google-recaptcha')
);

const submitFirstForm = () => {
  const $bookingNumber = $('#bookingNumberValidate');
  const $arrivalDate = $('#arrival-date-picker-validate');
  const $arrivalDateHidden = $('input[name="arrivalDate"]');
  const $resort = $('#resortCodeValidate');
  const $lastName = $('#lastNameValidate');
  const $errorMsg = $('#general-error');
  const $beachesLoader = $('.beaches-loader');
  const $htmlTag = $('html');
  const errors = [];

  const data = {
    bookingNumber: $bookingNumber.val(),
    arrivalDate: $arrivalDateHidden.val(),
    resort: $resort.val(),
    lastName: $lastName.val()
  };

  if($bookingNumber.val() === '') {
    // $bookingNumber.addClass('has-error');
    errors.push('booking Number');
  } else {
    $bookingNumber.removeClass('has-error');
  }
  if($arrivalDateHidden.val() === '') {
    // $arrivalDate.find('.datepicker-text').addClass('has-error');
    errors.push('arrival Date');
  } else {
    $arrivalDate.find('.datepicker-text').removeClass('has-error');
  }
  if($resort.val() === '') {
    // $resort.addClass('has-error');
    errors.push('resort');
  } else {
    $resort.removeClass('has-error');
  }
  if($lastName.val() === '') {
    // $lastName.addClass('has-error');
    errors.push('last name');
  } else {
    $lastName.removeClass('has-error');
  }

  if(errors.length > 0) {
    $errorMsg.html('Please fill all the fields above');

    return false;
  }

  $beachesLoader.removeClass('inactive').addClass('submitting-post');
  $htmlTag.addClass('html-no-scroll');

  $.ajax({
    method: 'GET',
    url: '/welcomehome/validate/',
    data: data,
    success: (response) => {
      if(response.status === 'success') {
        $('.form-body-hidden').fadeIn();
        $('#bookingNumberValidate').attr('readonly', true);
        $('#arrivalDate').attr('disabled', true);
        $('#resortSelect').attr('disabled', true);
        $('#resort').val($resort.val());
        $('#lastNameValidate').attr('readonly', true);

        $('#footer-validate').hide();
        $('#disclaimer-validate').hide();
      }

      if(
        response.data && response.data.message && response.data.message.sandalsSelectNumber &&
          response.data.message.sandalsSelectNumber.toString().length  === 16 ) {
        $('#ssgNumber').val(response.data.message.sandalsSelectNumber).attr('readonly',  true);
        $('#general-error').hide();
      } else {
        $errorMsg.html(response.data.message);
      }
    },
    error: (error) => {
      console.warn(error);
      $beachesLoader.addClass('inactive').removeClass('submitting-post');
      $('.err-msg').html('Sorry, we have an inconvenience with your request. Try Again').show();
    },
    complete: () => {
      $htmlTag.removeClass('html-no-scroll');
      $beachesLoader.addClass('inactive').removeClass('submitting-post');
    }
  });
};

const validateBookingBtn = document.getElementById('validate-booking');

validateBookingBtn.addEventListener('click', e => {
  e.preventDefault();
  submitFirstForm();
});

// Form validations
import '~/js/modules/fend';

const $reunionForm = $('.rsvp-second-form');

$reunionForm.fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    bookingNumber: 'alphanumeric',
    city: 'lettersOnly',
    sandalsSelectNumber: 'number',
    arrivalDate: 'date',
    departureDate: 'date',
  },
  isMultiPart: true
});
